import { render, staticRenderFns } from "./CorporationListItem.vue?vue&type=template&id=3f4b5703&"
import script from "./CorporationListItem.vue?vue&type=script&lang=js&"
export * from "./CorporationListItem.vue?vue&type=script&lang=js&"
import style0 from "./CorporationListItem.vue?vue&type=style&index=0&id=3f4b5703&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports